export type Tone = 'cyan' | 'green' | 'yellow' | 'red' | 'purple' | 'orange'

export function toneVar(tone: Tone): string {
  return `var(--${tone})`
}

export function toneGlow(tone: Tone): string {
  return `var(--glow-${tone})`
}
